export class ZefProgressState {
  progress: ZefProgress[];

  constructor() {
    this.progress = [];
  }
}

// TODO: interface
export interface ZefProgressConfig {
  meta?: any
}

export interface ZefProgress {
  key: string;
  id?: string | number;
  tag?: string;
  progress?: number;
  meta?: any;
}

export type ZefProgressMap = Record<string, Record<string, ZefProgress>>
